import { CURSOR_COLOR, TOOLS } from '../utils/constants.js';

/**
 * Overlay that draws the cursor ghost and stamp preview.
 */
export class CursorPreview {
  render(ctx, state, viewport) {
    const tx = state.get('cursorTileX');
    const ty = state.get('cursorTileY');
    if (tx < 0 || ty < 0) return;

    const mapW = state.get('mapWidth');
    const mapH = state.get('mapHeight');
    if (tx >= mapW || ty >= mapH) return;

    const tileW = state.get('tileWidth');
    const tileH = state.get('tileHeight');
    const tool = state.get('activeTool');

    // Draw cursor highlight
    ctx.fillStyle = CURSOR_COLOR;
    ctx.fillRect(tx * tileW, ty * tileH, tileW, tileH);

    // Draw selected tile preview for pencil tool
    if (tool === TOOLS.PENCIL || tool === TOOLS.RECT) {
      const stamp = state.get('stamp');
      if (stamp) {
        ctx.globalAlpha = 0.5;
        for (let sy = 0; sy < stamp.length; sy++) {
          for (let sx = 0; sx < stamp[sy].length; sx++) {
            const gid = stamp[sy][sx];
            if (gid > 0) {
              const rect = state.getTileRect(gid);
              if (rect) {
                const img = state.get('tilesetImages').get(rect.tileset.image);
                if (img) {
                  ctx.drawImage(
                    img,
                    rect.sx, rect.sy, rect.sw, rect.sh,
                    (tx + sx) * tileW, (ty + sy) * tileH, tileW, tileH
                  );
                }
              }
            }
          }
        }
        ctx.globalAlpha = 1;
      } else {
        const selectedTile = state.get('selectedTileId');
        if (selectedTile > 0) {
          ctx.globalAlpha = 0.5;
          const rect = state.getTileRect(selectedTile);
          if (rect) {
            const img = state.get('tilesetImages').get(rect.tileset.image);
            if (img) {
              ctx.drawImage(
                img,
                rect.sx, rect.sy, rect.sw, rect.sh,
                tx * tileW, ty * tileH, tileW, tileH
              );
            }
          }
          ctx.globalAlpha = 1;
        }
      }
    }
  }
}
